import { renewAndUpdateAdminSession, terminateAdminSession, useAdminSession } from '@cld/session-service';
import { useLoginAsFlow } from '../../components/GuestBar/useLoginAsFlow';
import { useCustomerIdContext } from '../../context';
import type { DisplayAssetsFormData } from '../../types';

export const useLoginAs = () => {
  const { currentCustomer } = useCustomerIdContext();
  const { adminSessionTimeLeft } = useAdminSession();

  // istanbul ignore next
  const reportViewAssets = (formData: DisplayAssetsFormData) => {
    // TODO: call GDPR with form content + remove istanbul comment
    console.log(formData);
  };

  // @ts-expect-error FIXME: Probably ?? '' would work but I will leave it to the team to decide
  const onRenewal = (): Promise<boolean> => renewAndUpdateAdminSession(currentCustomer?.externalId);

  return useLoginAsFlow(
    adminSessionTimeLeft,
    null, // TODO: change once implementing assets viewing
    terminateAdminSession,
    onRenewal,
    reportViewAssets
  );
};
